export const version = "2.6.10"


// WEBPACK FOOTER //
// ../src/version.ts